import Scene = Phaser.Scene;
import {lazyInject} from "@/container";
import {TYPES} from "@/types";
import {SceneService} from "@/services/scene-service";
import SceneUtils from "@/utils/scene-utils";
import {LoadUtils, LoaderState} from "@/utils/load-utils";
import {Keys} from "@/constants/key";
import BattleStore from "@/store/battle";
import {GameState} from "@/constants/game-state";
import {SceneName} from "@/model/scene-name";
import {ClanInfo} from "@/store/clan/types";
import ClanStore from "@/store/clan";
import ClanUtils from "@/utils/clan-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {Urls} from "@/constants/urls";
import Sprite = Phaser.GameObjects.Sprite;

export default class ClanLoadScene extends Scene {
    @lazyInject(TYPES.SceneService)
    private sceneService!: SceneService;

    private canvas!: HTMLCanvasElement;

    private progressShown: boolean = false;

    private loaderState!:LoaderState;

    constructor() {
        super({ key: 'ClanLoadScene' });
    }

    public preload(): void {
        this.canvas = this.sys.game.canvas;
        SceneUtils.setCurrentScene(this);
    }

    public create(): void {
        if (!GameState.CLAN_RESOURCES_LOADED) {

            this.load.image(Keys.CL_ABOUT, 'assets/clan/cl_about.png');
            this.load.image(Keys.CL_BUDGET, 'assets/clan/cl_budget.png');
            this.load.image(Keys.CL_BUILD, 'assets/clan/cl_build.png');
            this.load.image(Keys.CL_CHAT, 'assets/clan/cl_chat.png');
            this.load.image(Keys.CL_FAME, 'assets/clan/cl_fame.png');
            this.load.image(Keys.CL_HEADER, `assets/clan${Urls.CURRENT_UI_STYLE}/cl_header${Urls.CURRENT_UI_STYLE}.png`);
            this.load.image(Keys.CL_MEMEBERS, 'assets/clan/cl_members.png');
            this.load.image(Keys.CL_ADVERTISEMENT, 'assets/clan/cl_advertisement.png');
            this.load.image(Keys.CL_OTHER, 'assets/clan/cl_other.png');
            this.load.image(Keys.CL_RAID, 'assets/clan/cl_raid.png');
            this.load.image(Keys.CL_RATING, 'assets/clan/cl_rating.png');
            this.load.image(Keys.CL_SHOP, 'assets/clan/cl_shop.png');
            this.load.image(Keys.CL_RECRUITING, 'assets/clan/cl_recruiting.png');
            this.load.image(Keys.CL_FORUM, 'assets/clan/cl_forum.png');
            this.load.image(Keys.CL_ACADEMY, 'assets/clan/cl_academy.png');
            this.load.image(Keys.CL_GUILD, 'assets/clan/cl_guild.png');
            this.load.image(Keys.CL_LAB, 'assets/clan/cl_lab.png');
            this.load.image(Keys.CL_FACTORY, 'assets/clan/cl_factory.png');
            this.load.image(Keys.CL_HALL, 'assets/clan/cl_hall.png');
            this.load.image(Keys.CL_HAMMER, 'assets/clan/build_ham.png');
            this.load.image(Keys.CLAN_GEAR_2, 'assets/clan/gear_2.png');
            this.load.image(Keys.CLAN_GEAR_3, 'assets/clan/gear_3.png');
            this.load.image(Keys.CLAN_GEAR_4, 'assets/clan/gear_4.png');

            this.load.image(Keys.CL_SMALL_RED_BUTTON, 'assets/clan/small-red-button.png');
            this.load.image(Keys.CL_BLACK_SQUARE, 'assets/clan/black-square.png');

            this.load.audio(Keys.MUSIC_CLAN, ['assets/sound/ogg/rest-in-the-forrest.ogg', 'assets/sound/mp3/rest-in-the-forrest.mp3']);

            GameState.CLAN_RESOURCES_LOADED = true;
        }
        let ci: ClanInfo | undefined = ClanStore.getClanInfo();
        if (ci && ci.clan) {
            let clan = ci.clan;
            let themeNumber = clan.clanThemeNumber;
            ClanUtils.loadClanTheme(this, this.canvas, themeNumber);
        }
        this.load.start();
        this.showProgress();
    }

    private showProgress() {
        if (!this.progressShown) {
            this.loaderState = new LoaderState();
            // LoadUtils.drawClouds(this, this.canvas);
            LoadUtils.drawLoadingScreen(this);
            LoadUtils.showSimpleLoadingScreen(this, this.canvas, this.loaderState);
        } else if(this.load.isReady()) {
            this.proceedToScreen();
            return;
        }

        this.load.once(Phaser.Loader.Events.COMPLETE, () => {
            this.proceedToScreen();
        });
    }

    private proceedToScreen(){
        this.progressShown = true;
        this.scene.start(SceneService.getSceneKey(SceneName.CLAN_SCENE), undefined);
    }

    update(time: number, delta: number){
        if(this.loaderState) {
            this.loaderState.update(time, delta);
        }
    }

}
